var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_2124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4320",
    className: "st0",
    d: "M4,14c0,0.7,0.1,1.3,0.2,2H0.1c-0.6-4,0.6-8.1,3.3-11.2L1.3,2.7C1,2.4,0.9,2,1.1,1.6 C1.2,1.2,1.6,1,2,1h7c0.6,0,1,0.4,1,1v7c0,0.6-0.4,1-1,1c-0.3,0-0.5-0.1-0.7-0.3l-2-2C4.8,9.5,4,11.7,4,14 M16,23.8v4.1 c-4,0.6-8.1-0.6-11.2-3.3l-2.1,2.1c-0.4,0.4-1,0.4-1.4,0C1.1,26.5,1,26.3,1,26v-7c0-0.6,0.4-1,1-1h7c0.6,0,1,0.4,1,1 c0,0.3-0.1,0.5-0.3,0.7l-2,2C10,23.6,13.1,24.4,16,23.8 M12,4.2V0.1c4-0.6,8.1,0.6,11.2,3.3l2.1-2.1C25.6,1,26,0.9,26.4,1.1 C26.8,1.2,27,1.6,27,2v7c0,0.6-0.4,1-1,1h-7c-0.6,0-1-0.4-1-1c0-0.3,0.1-0.5,0.3-0.7l2-2C18,4.4,14.9,3.6,12,4.2 M28,14 c0,3.4-1.2,6.6-3.4,9.2l2.1,2.1c0.3,0.3,0.4,0.7,0.2,1.1C26.8,26.8,26.4,27,26,27h-7c-0.6,0-1-0.4-1-1v-7c0-0.6,0.4-1,1-1 c0.3,0,0.5,0.1,0.7,0.3l2,2c1.9-2.3,2.7-5.4,2.1-8.3h4.1C28,12.7,28,13.3,28,14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateIcon);
export default __webpack_public_path__ + "static/media/Generate_icon.3d315dd500ede1f16e85365f181a6bb0.svg";
export { ForwardRef as ReactComponent };